import { backendGet } from '../lib/backendClient';

export async function getRouteDirections({ start, end, profile = 'driving-car' }) {
  if (!start || !end) return null;

  const params = new URLSearchParams({
    start_lat: String(start.lat),
    start_lng: String(start.lng),
    end_lat: String(end.lat),
    end_lng: String(end.lng),
    profile
  });

  return await backendGet(`/api/routes/directions?${params.toString()}`);
}
export async function reverseGeocode({ lat, lng }) {
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  const params = new URLSearchParams({
    lat: String(lat),
    lng: String(lng),
  });
  return await backendGet(`/api/routes/reverse-geocode?${params.toString()}`);
}

export async function geocodeAddress({ text, street, number, neighborhood, city, state, zipcode, country }) {
  const params = new URLSearchParams();
  if (text) params.set('text', text);
  if (street) params.set('street', street);
  if (number) params.set('number', number);
  if (neighborhood) params.set('neighborhood', neighborhood);
  if (city) params.set('city', city);
  if (state) params.set('state', state);
  if (zipcode) params.set('zipcode', zipcode);
  if (country) params.set('country', country);
  if ([...params.keys()].length === 0) return null;
  return await backendGet(`/api/routes/geocode?${params.toString()}`);
}
